/**
 * @author Jersson Morales
 * @Copyright (c) Infotrack. All rights reserved.
 */
import { useProveedor } from '@infotrack/presentacion-componentes/proveedorEstado';
import Texto from '@infotrack/presentacion-componentes/texto';
import { TipoFormulario } from '@infotrack/presentacion-transversales/interfacesComunes';
import {
    manejadorDialogoGlobal,
    manejadorIndicadorCargaGlobal,
} from '@infotrack/presentacion-utilitarios/manejadoresComponentes';
import ITipoRegimen from 'Infotrack@Modelos/administracion/tipoRegimen/entidades/tipoRegimen';
import React from 'react';
import TipoRegimenCM from '../controladorModelo/tipoRegimenCM';
import { acciones, IEstadoTipoRegimen } from '../reductorTipoRegimen';
import TipoRegimenVista from '../vista/tablaTipoRegimenVista';

const tipoRegimenCM = new TipoRegimenCM();

const TableTipoRegimenCV: React.FunctionComponent = () => {
    const cargaInicial = React.useRef(true);
    const [tipoRegimens, setTipoRegimens] = React.useState<ITipoRegimen[]>([]);
    const [{ recargarTabla }, dispatch] = useProveedor<IEstadoTipoRegimen>();

    React.useEffect(() => {
        if (recargarTabla || cargaInicial.current) {
            cargarTipoRegimen();
            if (recargarTabla) {
                dispatch({ type: acciones.RECARGAR_TABLA });
            }
        }
        cargaInicial.current = false;
    });

    const cargarTipoRegimen = () => {
        manejadorIndicadorCargaGlobal(true);
        tipoRegimenCM.consultarTipoRegimen().then((tipoRegimens) => {
            setTipoRegimens(tipoRegimens);
            manejadorIndicadorCargaGlobal(false);
        });
    };
    const manejarFormulario = (tipoFormulario: TipoFormulario, entidadTipoRegimen?: ITipoRegimen) => {
        dispatch({ type: acciones.CAMBIAR_ESTADO_FORMULARIO, payload: { entidadTipoRegimen, tipoFormulario } });
    };

    const confirmarEliminacion = (tipoRegimen: ITipoRegimen) => {
        manejadorDialogoGlobal({
            accionCancelar: () => manejadorDialogoGlobal({ estado: false }),
            accionConfirmar: () => eliminarTipoRegimen(tipoRegimen),
            estado: true,
            mensaje: <Texto id={'alerta.confirmacionEliminacion'} />,
            mostrarCancelar: true,
            tipoDialogo: 'Advertencia',
            titulo: <Texto id="titulo.advertencia" />,
        });
    };
    const eliminarTipoRegimen = (tipoRegimen: ITipoRegimen) => {
        manejadorIndicadorCargaGlobal(true);
        manejadorDialogoGlobal({ estado: false });
        tipoRegimenCM.eliminarTipoRegimen(tipoRegimen).then(() => {
            manejadorIndicadorCargaGlobal(false);
            dispatch({ type: acciones.RECARGAR_TABLA });
        });
    };

    return (
        <TipoRegimenVista
            tipoRegimens={tipoRegimens}
            cargarTipoRegimen={cargarTipoRegimen}
            confirmarEliminacion={confirmarEliminacion}
            manejarFormulario={manejarFormulario}
        />
    );
};

export default TableTipoRegimenCV;
